module.exports = __webpack_public_path__ + "media/images/partners/airtel-851a3230c1de44655e59605b4da1f698.jpeg";